import { Extension } from "@tiptap/core";

const FontSize = Extension.create({
  name: "fontSize",

  addOptions() {
    return {
      types: ["textStyle"],
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (element) => element.style.fontSize || null,
            renderHTML: (attributes) => {
              if (!attributes.fontSize) {
                return {};
              }

              const sizeMap = {
                tiny: "10px",
                small: "12px",
                default: "14px",
                big: "18px",
                huge: "24px",
              };

              return {
                style: `font-size: ${sizeMap[attributes.fontSize] || attributes.fontSize}`,
              };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setFontSize:
        (fontSize) =>
        ({ chain, state, dispatch }) => {
          // If no selection, apply to the current text style mark
          if (state.selection.empty) {
            // Check if there's an active textStyle mark
            const { $from } = state.selection;
            const marks = $from.marks();
            const textStyleMark = marks.find(mark => mark.type.name === "textStyle");
            
            if (textStyleMark) {
              // Update existing mark
              return chain()
                .setMark("textStyle", { ...textStyleMark.attrs, fontSize })
                .run();
            } else {
              // Set mark for future typing
              return chain()
                .setMark("textStyle", { fontSize })
                .run();
            }
          }
          // Apply to selection
          return chain().setMark("textStyle", { fontSize }).run();
        },
      unsetFontSize:
        () =>
        ({ chain, state }) => {
          // If no selection, remove from current mark
          if (state.selection.empty) {
            const { $from } = state.selection;
            const marks = $from.marks();
            const textStyleMark = marks.find(mark => mark.type.name === "textStyle");
            
            if (textStyleMark && textStyleMark.attrs.fontSize) {
              const newAttrs = { ...textStyleMark.attrs };
              delete newAttrs.fontSize;
              if (Object.keys(newAttrs).length === 0) {
                return chain().unsetMark("textStyle").run();
              }
              return chain().setMark("textStyle", newAttrs).run();
            }
            return false;
          }
          // Remove from selection
          return chain().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run();
        },
    };
  },
});

export default FontSize;
